<template>
  <modal :size="'dialog'">
    <div class="modal-header">
      <h4 v-if="!$slots['header-title']">ยืนยันการลบ</h4>
      <slot v-if="$slots['header-title']"
      name="header-title" />
      <button
        @click.stop="onClose"
        type="button"
        class="btn btn-link btm-sm btn-close-container">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <slot></slot>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-outline-danger"
        type="button"
        @click.stop="onConfirm">
        ยืนยัน
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
  props: {
    onClose: { type: Function, default: () => {} },
    onConfirm: { type: Function, default: () => {} },
  },
  components: {
    Modal,
  },
};
</script>

<style lang="scss" scoped>

</style>
